import React from 'react';
import { Link } from 'react-router-dom';
import { FaSpinner, FaQuestionCircle, FaClock } from 'react-icons/fa';

export const LoadingScreen = () => (
  <div className="min-h-screen bg-gray-50 flex items-center justify-center">
    <div className="text-center">
      <FaSpinner className="animate-spin text-4xl text-blue-600 mx-auto mb-4" />
      <p className="text-gray-600">Loading your dashboard...</p>
    </div>
  </div>
);

export const NoProfileScreen = () => (
  <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
    <div className="bg-white rounded-xl shadow-lg p-8 max-w-md w-full text-center">
      <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
        <FaQuestionCircle className="text-blue-600 text-3xl" />
      </div>
      <h2 className="text-xl font-bold text-gray-800 mb-2">No Professional Profile</h2>
      <p className="text-gray-600 mb-6">
        You don't have a professional profile yet. Would you like to apply to join our network?
      </p>
      <div className="space-y-3">
        <Link
          to="/become-partner"
          className="block w-full px-4 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 font-medium"
        >
          Learn About Partnering
        </Link>
        <Link
          to="/professionals/signup"
          className="block w-full px-4 py-3 border border-blue-600 text-blue-600 rounded-lg hover:bg-blue-50 font-medium"
        >
          Apply Now
        </Link>
        <Link
          to="/dashboard"
          className="block w-full px-4 py-3 text-gray-600 hover:text-gray-800"
        >
          Go to Family Dashboard
        </Link>
      </div>
    </div>
  </div>
);

export const PendingApprovalScreen = () => (
  <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
    <div className="bg-white rounded-xl shadow-lg p-8 max-w-md w-full text-center">
      <div className="w-16 h-16 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-4">
        <FaClock className="text-amber-600 text-3xl" />
      </div>
      <h2 className="text-xl font-bold text-gray-800 mb-2">Pending Approval</h2>
      <p className="text-gray-600 mb-6">
        Your professional profile is currently under review. We'll notify you once it's approved.
      </p>
      <div className="bg-amber-50 border border-amber-200 rounded-lg p-4 mb-6">
        <p className="text-sm text-amber-800">
          This usually takes 24-48 hours. Thank you for your patience!
        </p>
      </div>
      <Link
        to="/dashboard"
        className="block w-full px-4 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 font-medium"
      >
        Go to Family Dashboard
      </Link>
    </div>
  </div>
);
